<template>
  <div>
    <div class="step-section">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <h2>
            <span class="form-group">
              <span
                class="glyphicon glyphicon-envelope"
                aria-hidden="true"
                data-toggle="tooltip"
                data-placement="top"
                title="Email might be generated"
              ></span>
              Items for Farm Services
              <comments field-name="items_for_farm_services" :isReadOnly="isReadOnly"> </comments>
            </span>
          </h2>

          <radio-input
            label="PP+"
            field-name="disclaimer_ppp"
            :choices="[
              { value: 'Not required', display: 'Not required' },
              { value: 'Completed/Booked', display: 'Completed/Booked' },
              { value: 'Booking required', display: 'Booking required' },
            ]"
            :disabled="isReadOnly"
          >
          </radio-input>

          <radio-input
            label="May scan"
            field-name="disclaimer_may_scan"
            :choices="[
              { value: 'Not required', display: 'Not required' },
              { value: 'Completed/Booked', display: 'Completed/Booked' },
              { value: 'Booking required', display: 'Booking required' },
            ]"
            :disabled="isReadOnly"
          >
          </radio-input>
        </div>
      </div>
    </div>

    <div class="step-section">
      <h2>Disclaimer and teatseal documentation</h2>

      <radio-input
        label=""
        field-name="disclaimer_signed_at_consult"
        :choices="[
          { value: true, display: 'Disclaimer completed during consult' },
          { value: false, display: 'Email disclaimer to client' },
        ]"
        :disabled="isReadOnly"
      >
      </radio-input>
    </div>
    <template v-if="getFieldValue('disclaimer_signed_at_consult') == false">
      <div class="form-group">
        <p>
          An email will be sent to the selected address. The email will include an attached legal disclaimer document.
          Please reply to the email as soon as possible and acknowledge that you have read and agree to the attached
          teat seal advice and legal disclaimer. Products cannot be purchased until this acknowledgement reply is
          received.
        </p>
      </div>

      <div class="step-section">
        <div class="form-group form-inline text-left confirmation-text">
          <span> Email will be addressed to </span>
          <text-input
            label=""
            field-name="client_consulter"
            required
            :disabled="isReadOnly || regulationEmailAlreadySent"
          >
          </text-input>
          <br />
          <span> and sent to this address </span>
          <select-input
            label=""
            field-name="regulation_email_receivers"
            required
            :disabled="isReadOnly || regulationEmailAlreadySent"
            :options="regulationEmailChoices"
          >
          </select-input>
          <email-input
            v-if="getFieldValue('regulation_email_receivers') == 'other'"
            label=""
            required
            style="margin-top: 20px; margin-left: 5px"
            field-name="other_regulation_email_receivers"
            :disabled="isReadOnly || regulationEmailAlreadySent"
          >
          </email-input>
          <br />
          <br />

          <button
            class="btn btn-warning"
            v-if="!isReadOnly"
            type="button"
            :class="{ disabled: !canSubmitRegulationEmail }"
            v-tooltip="submitRegulationEmailTooltip"
            @click="canSubmitRegulationEmail ? sendRegulationEmail() : ''"
          >
            Send Now
          </button>
          <button v-if="false" class="btn btn-default" @click="resetRegulationEmail">Send to different address</button>
          <br />
          <br />
          <div class="alert alert-danger" v-if="regulation_email_status == 'failed'">Email failed to send</div>
          <div class="alert alert-success" v-if="regulation_email_status == 'success'">Email sent successfully</div>
        </div>
      </div>
    </template>

    <button
      v-if="!isReadOnly"
      class="btn btn-primary"
      type="button"
      @click="hasRegulationEmailData ? saveAndRedirectHome() : ''"
      :disabled="!hasRegulationEmailData"
    >
      Save and continue
    </button>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { consultFormService } from '@/_services'
import { mapGetters } from 'vuex'

export default {
  name: 'Disclaimer',
  mixins: [baseComponent],
  data() {
    return {
      regulation_email_status: 'none',
    }
  },
  mounted: function () {
    this.setFieldValue({
      fieldName: 'client_consulter_name',
      value: this.getFieldValue('client_consulter_name', 'DryCowAndTeatsealOrder'),
    })
  },
  methods: {
    resetRegulationEmail: function () {
      this.setFieldValue({ fieldName: 'regulation_email_sent_at', value: null })
    },
    sendRegulationEmail: function () {
      consultFormService
        .sendRegulationEmail({
          client_id: this.$route.params.client_id,
          season: this.$route.params.season,
          client_consulter: this.getFieldValue('client_consulter'),
          regulation_email_receivers: this.getFieldValue('regulation_email_receivers'),
          other_regulation_email_receivers: this.getFieldValue('other_regulation_email_receivers'),
        })
        .then(() => {
          this.regulation_email_status = 'success'
          this.setFieldValue({
            fieldName: 'regulation_email_sent_at',
            value: new Date().toJSON(),
          })
        })
        .catch(() => {
          this.regulation_email_status = 'failed'
          this.setFieldValue({
            fieldName: 'regulation_email_sent_at',
            value: null,
          })
        })
        .finally(() => {
          this.setEmailNotification({
            slug: 'dc-disclaimer-and-teatseal-documentation',
            value: !this.getFieldValue('regulation_email_sent_at', this.$options.name),
          })
        })
    },
    saveAndRedirectHome: function () {
      this.setSignedDate()
      this.onSubmit()
      this.$store.dispatch('alert/success', {
        message: 'Data has been saved locally',
        persist: true,
      })
      this.$router.push('/')
    },
    setSignedDate: function () {
      this.setFieldValue({
        fieldName: 'signed',
        modelName: this.$options.name,
        value: true,
      })
      this.setFieldValue({
        fieldName: 'signed_at',
        modelName: this.$options.name,
        value: new Date().toJSON(),
      })
    },
  },
  computed: {
    ...mapGetters('connection', ['online']),
    regulationEmailAlreadySent: function () {
      return this.getFieldValue('regulation_email_sent_at')
    },
    submitRegulationEmailTooltip: function () {
      if (this.regulationEmailAlreadySent) {
        return 'Email already sent'
      }
      if (!this.online) {
        return 'You need to be online to send the regulation email.'
      }
      if (!this.canSubmitRegulationEmail) {
        return 'Please fill the email receiver field.'
      }
      return null
    },
    canSubmitRegulationEmail: function () {
      if (this.regulationEmailAlreadySent) {
        return false
      }
      if (!this.online) {
        return false
      }
      return this.hasRegulationEmailData //&& this.regulation_email_status != 'success'
    },
    hasRegulationEmailData: function () {
      return (
        this.getFieldValue('disclaimer_signed_at_consult', this.$options.name) ||
        (Boolean(this.getEmailRegulationReceivers) && this.getFieldValue('client_consulter', this.$options.name))
      )
    },
    regulationEmailChoices: function () {
      return this.getFieldValue('regulation_email_choices').concat([
        { value: 'other', display: 'Other (please specify)' },
      ])
    },
    getEmailRegulationReceivers: function () {
      return this.getFieldValue(
        this.getFieldValue('regulation_email_receivers') == 'other'
          ? 'other_regulation_email_receivers'
          : 'regulation_email_receivers'
      )
    },
  },
}
</script>

<style scoped>
.confirmation-text p,
span {
  font-size: 20px;
  padding-left: 10px;
}
.confirmation-text {
  margin-bottom: 30px;
}
.borderless td,
.borderless th {
  border: none;
}
</style>
